'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _ChatAreaAlert = require('conversations-internal-components/visitor-widget/ChatAreaAlert');

var _ChatAreaAlert2 = _interopRequireDefault(_ChatAreaAlert);

var _attachmentErrors = require('../../file-uploads/constants/attachmentErrors');

var _fileUploadsConstants = require('../../file-uploads/constants/fileUploadsConstants');

var _identifierForThread = require('../../file-uploads/operators/identifierForThread');

var _FilePickerLink = require('../../file-uploads/components/FilePickerLink');

var _FilePickerLink2 = _interopRequireDefault(_FilePickerLink);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatAreaAlertContainer = function (_React$Component) {
  _inherits(ChatAreaAlertContainer, _React$Component);

  function ChatAreaAlertContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatAreaAlertContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatAreaAlertContainer.__proto__ || Object.getPrototypeOf(ChatAreaAlertContainer)).call.apply(_ref, [this].concat(args))), _this), _this.dismissAttachmentsError = function () {
      _this.props.dismissAttachmentsError({
        threadId: (0, _identifierForThread.identifierForThread)(_this.props.thread)
      });
    }, _this.selectAttachmentFile = function (_ref2) {
      var files = _ref2.target.files;

      if (!files || !files.length) {
        return;
      }

      var file = files.item(0);

      _this.props.selectAttachmentFile({
        file: file,
        thread: _this.props.thread
      });
    }, _this.trackTryAgain = function () {
      _this.props.trackInteraction('retry-attachment-upload', {
        action: 'retry attachment upload'
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatAreaAlertContainer, [{
    key: 'renderTryAgainLink',
    value: function renderTryAgainLink() {
      return _react2.default.createElement(
        _FilePickerLink2.default,
        {
          onChange: this.selectAttachmentFile,
          onClick: this.trackTryAgain
        },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'cvVisitorUIAttachments.tryAgain' })
      );
    }
  }, {
    key: 'renderAlertTitle',
    value: function renderAlertTitle() {
      switch (this.props.attachmentsError) {
        case _attachmentErrors.SIZE_LIMIT_EXCEEDED:
          return _react2.default.createElement(_FormattedMessage2.default, {
            message: 'cvVisitorUIAttachments.errors.fileSizeExceeded',
            options: {
              maxSize: _I18n2.default.formatSize(_fileUploadsConstants.MAX_FILE_SIZE)
            }
          });
        case _attachmentErrors.BLACKLISTED_EXTENSION:
          return _react2.default.createElement(_FormattedMessage2.default, { message: 'cvVisitorUIAttachments.errors.blacklistedExtension' });
        case _attachmentErrors.UPLOAD_ERROR:
          return _react2.default.createElement(_FormattedMessage2.default, { message: 'cvVisitorUIAttachments.errors.uploadError' });
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.attachmentsError) {
        return null;
      }

      return _react2.default.createElement(_ChatAreaAlert2.default, {
        title: this.renderAlertTitle(),
        onClose: this.dismissAttachmentsError,
        link: this.renderTryAgainLink()
      });
    }
  }]);

  return ChatAreaAlertContainer;
}(_react2.default.Component);

ChatAreaAlertContainer.propTypes = {
  attachmentsError: _react.PropTypes.oneOf([_attachmentErrors.SIZE_LIMIT_EXCEEDED, _attachmentErrors.BLACKLISTED_EXTENSION, _attachmentErrors.UPLOAD_ERROR]),
  dismissAttachmentsError: _react.PropTypes.func.isRequired,
  selectAttachmentFile: _react.PropTypes.func.isRequired,
  thread: (0, _RecordPropType2.default)('Conversation').isRequired,
  trackInteraction: _react.PropTypes.func.isRequired
};

exports.default = ChatAreaAlertContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/components/ChatAreaAlertContainer.js
// module id = 1171
// module chunks = 2 3